import { render, staticRenderFns } from "./PermitAction.vue?vue&type=template&id=764514e7"
import script from "./PermitAction.vue?vue&type=script&lang=js"
export * from "./PermitAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports